export const STEPS = ['creation', 'revision', 'approval'] as const;